import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const PDFIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M8.55 12.35h.7v-2h1.625l.375-.375v-1.95l-.375-.375H8.55v4.7Zm.7-2.7v-1.3h1.3v1.3h-1.3Zm3.05 2.7h2.225l.375-.375v-3.95l-.375-.375H12.3v4.7Zm.7-.7v-3.3h1.2v3.3H13Zm3.2.7h.7v-2h1.5v-.7h-1.5v-1.3h1.5v-.7h-2.2v4.7ZM6.65 16.7V3.3h13.4v13.4H6.65Zm.7-.7h12V4h-12v12Zm-3.4 3.4V6.8h.7v11.9h11.9v.7H3.95Z"
      />
    </svg>
  </IconWrapper>
));
